const VersionInfo = ({
    env,
    version,
    branch,
}: {
    env: string;
    version: string;
    branch: string;
}) => {
    return (
        <div className="flex flex-col gap-y-2 Body-Medium w-fit p-4 border bg-blue-300 border-blue-800 rounded-lg">
            <InfoSection label={'Env:'} value={env} />
            <InfoSection label={'Branch:'} value={branch} />
            <InfoSection label={'API:'} value={version} />
        </div>
    );
};

export default VersionInfo;

const InfoSection = ({ label, value }: { label: string; value: string }) => {
    return (
        <div className="flex flex-row gap-x-1">
            <h4 className="font-semibold ">{label}</h4>
            <p className="text-neutral-800 dark:text-neutral-800 break-all">
                {value}
            </p>
        </div>
    );
};
